import { render, staticRenderFns } from "./TaskDetailsWatchers.vue?vue&type=template&id=050414e6"
import script from "./TaskDetailsWatchers.vue?vue&type=script&lang=js"
export * from "./TaskDetailsWatchers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports